import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-select-country',
  templateUrl: './select-country.component.html',
styleUrls:  ['./select-country.component.css']
})
export class SelectCountryComponent implements OnInit {
  @Input() selected_country: string;
  @Input() disabled: boolean;
  @Output() country_selected$: EventEmitter<any> = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {
  }

  handleSelectionChange(){
  	this.country_selected$.emit(this.selected_country);
  }

}
